export const dataFichaContactologia = {
  codigo: null,
  tienda_id: null,
  paciente_id: null,
  nombre_tienda: null,
  tipo_ficha: null,
  numero_prueba_lentilla: null,
  fecha: null,
  fecha_proxima_graduacion: null,
  atendido_por_id: null,
  atendido_por_nombre: null,
  prescriptor_id: null,
  prescriptor_nombre: null,
  graduacion_optometrica_asociada: null,
  sistema_limpieza: null,
  av_binocular: null,
  numero_lote: null,
  observaciones: null,
  esGraduacion0: null,
  tipo_respuesta: null,
};
